import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, BarChart3, Inbox, ShieldCheck } from "lucide-react";
import { ShieldMark } from "../../components/onix/ShieldMark";
import { adminAxios } from "../../lib/admin";
import AdminAnalytics from "./AdminAnalytics";
import AdminInbox from "./AdminInbox";
import AdminSecurity from "./AdminSecurity";

export default function AdminPanel() {
  const [ready, setReady] = useState(false);
  const [tab, setTab] = useState("analitica");
  const [newCount, setNewCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Panel de administración | ONIX";
    adminAxios
      .get("/auth/me")
      .then(() => setReady(true))
      .catch(() => navigate("/admin"));
  }, [navigate]);

  const logout = async () => {
    try {
      await adminAxios.post("/auth/logout");
    } catch {
      /* noop */
    }
    navigate("/admin");
  };

  if (!ready) {
    return (
      <main className="min-h-screen bg-onix-black flex items-center justify-center">
        <p className="tech-label">VERIFICANDO ACCESO…</p>
      </main>
    );
  }

  const tabClass = (active) =>
    `inline-flex items-center gap-2 px-5 py-3 text-[11px] font-bold uppercase tracking-[0.14em] border-b-2 transition-colors ${
      active ? "border-onix-white text-onix-white" : "border-transparent text-onix-gray hover:text-onix-silver"
    }`;

  return (
    <main data-testid="admin-panel" className="min-h-screen bg-onix-black">
      <header className="border-b border-onix-line bg-onix-black2">
        <div className="onix-shell flex items-center justify-between h-[68px]">
          <div className="flex items-center gap-4">
            <ShieldMark variant="white" className="w-[44px]" eager alt="Escudo ONIX" />
            <div className="leading-none">
              <p className="font-sans font-bold text-sm tracking-[0.25em] text-onix-white">ONIX</p>
              <p className="tech-label mt-1 !text-[9px]">PANEL DE ADMINISTRACIÓN</p>
            </div>
          </div>
          <div className="flex items-center gap-5">
            <Link data-testid="admin-view-site" to="/" className="text-[11px] font-bold uppercase tracking-[0.14em] text-onix-gray hover:text-onix-white transition-colors">
              Ver sitio
            </Link>
            <button data-testid="admin-logout" onClick={logout} className="btn-onix-secondary !px-4 !py-2 inline-flex items-center gap-2">
              <LogOut size={13} aria-hidden="true" />
              Salir
            </button>
          </div>
        </div>
      </header>

      <nav className="border-b border-onix-line" aria-label="Secciones del panel">
        <div className="onix-shell flex">
          <button data-testid="admin-tab-analitica" className={tabClass(tab === "analitica")} onClick={() => setTab("analitica")}>
            <BarChart3 size={14} aria-hidden="true" />
            Analítica
          </button>
          <button data-testid="admin-tab-buzon" className={tabClass(tab === "buzon")} onClick={() => setTab("buzon")}>
            <Inbox size={14} aria-hidden="true" />
            Buzón
            {newCount > 0 && (
              <span data-testid="admin-inbox-badge" className="ml-1 bg-onix-white text-onix-black text-[10px] font-bold px-2 py-0.5">
                {newCount}
              </span>
            )}
          </button>
          <button data-testid="admin-tab-seguridad" className={tabClass(tab === "seguridad")} onClick={() => setTab("seguridad")}>
            <ShieldCheck size={14} aria-hidden="true" />
            Seguridad
          </button>
        </div>
      </nav>

      <div className="onix-shell py-10">
        {tab === "analitica" && <AdminAnalytics onNewMessages={setNewCount} />}
        {tab === "buzon" && <AdminInbox onNewMessages={setNewCount} />}
        {tab === "seguridad" && <AdminSecurity />}
      </div>
    </main>
  );
}
